import { render, staticRenderFns } from "./m4box.vue?vue&type=template&id=4ff472b5&scoped=true"
import script from "./m4box.vue?vue&type=script&lang=js"
export * from "./m4box.vue?vue&type=script&lang=js"
import style0 from "./m4box.vue?vue&type=style&index=0&id=4ff472b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff472b5",
  null
  
)

export default component.exports